import React, { useState } from "react";

import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiSpacer,
  EuiButton,
  EuiCallOut,
} from "@elastic/eui";
import { useDispatch, useSelector } from "react-redux";
import { uploadInvoices } from "../../features/invoices/invoices.thunk";
import { FilePond, registerPlugin } from "react-filepond";
import { selectUploadedInvoices } from "../../features/invoices/invoices.slice";

import JsonViewer from "../../components/JsonViewer/JsonViewer";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

import "filepond/dist/filepond.min.css";

// Register the plugin
registerPlugin(FilePondPluginFileValidateType);

const UploadInvoicePage = () => {
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const jsonContent = useSelector(selectUploadedInvoices);
  const uploadPdfs = async () => {
    const formData = new FormData();
    files.forEach(({ file }) => formData.append("pdfs", file));
    dispatch(uploadInvoices(formData));
  };

  return (
    <div className="w-full">
      <EuiCallOut
        size="s"
        title="Note : You can upload multiple pdf files (upto 200 file per upload and Only supports Invoice PDFs : einv*.pdf)"
        iconType="pin"
      />
      <EuiSpacer size="s" />
      <EuiFlexGroup>
        <EuiFlexItem grow={1} className="max-550">
          <FilePond
            allowMultiple={true}
            files={files}
            onupdatefiles={setFiles}
            acceptedFileTypes={["application/pdf"]}
          />
        </EuiFlexItem>
        <EuiFlexItem className="min-w-300" grow={1}>
          <JsonViewer jsonContent={JSON.stringify(jsonContent, null, 4)} />
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiFlexGroup>
        <EuiFlexItem grow={true}>
          <EuiButton fullWidth iconType="lensApp" onClick={() => uploadPdfs()}>
            Upload
          </EuiButton>
        </EuiFlexItem>
      </EuiFlexGroup>
    </div>
  );
};

export default UploadInvoicePage;
